module.exports = __webpack_public_path__ + "img/konstantin.4fc6495f.webp";